export default function ParamError({ kind }: { kind: 'missing_place_id' | 'missing_user_id' }) {
  const param = kind === 'missing_place_id' ? 'place_id' : 'user_id'

  return (
    <div className="flex h-full flex-col items-center justify-center space-y-2 bg-bg text-text-mid">
      <img src="/images/logo-horizontal.svg" alt="Loving Loyalty" className="mb-4 h-9" />
      <div className="font-volte text-xl text-text-hi">Invalid display URL</div>
      <div className="font-mono text-sm">missing {param}</div>
    </div>
  )
}
